import { SafeHtml } from "@angular/platform-browser";

// Banner della colonna di destra dell'hero (immagini 2 e 3 della slide)
export interface GallerySideImage {
    src: string;
    // path interno (/c/i/...) o URL https; null = immagine non cliccabile
    link: string | null;
}

// Interfaccia per la struttura di ogni slide
export interface GallerySlideContent {
    imageUrl: string;
    // Dimensioni intrinseche dell'immagine originale (per srcset/width/height)
    width: number;
    height: number;
    // Il contenuto HTML statico con i placeholder per le traduzioni
    html_content: string;
    // keys delle traduzioni usate nei placeholder
    trad_keys: string[];
    // Moltiplicatore della durata di permanenza rispetto all'intervallo base (default 1)
    durationFactor?: number;
    // Slide stagionale: mostrata solo nel periodo del tema (vedi SeasonalThemeService)
    season?: 'halloween';
    // Banner 2 e 3 propri della slide; null/assente = banner standard
    sideImages?: (GallerySideImage | null)[];
}

// Array con i dati delle slide
// Slide Halloween: true = pipistrelli animati (sfondo senza pipistrelli + sprite animati),
// false = immagine statica originale con i pipistrelli dipinti nello sfondo.
const HALLOWEEN_ANIMATED_BATS = true;

// I due pipistrelli sono stati rimossi dallo sfondo e sovrapposti come sprite animati
// (posizioni/larghezze in % = coordinate originali nell'immagine, stili in slide.component.scss).
export const HALLOWEEN_BATS_HTML = ` <div class="halloween-bat halloween-bat-a" aria-hidden="true" style="left: 76.85%; top: 21.96%; width: 4.9%;">
                            <img src="images/home_gallery/slider/000-halloween-bat-a.webp" width="82" height="33" alt="" />
                        </div>
                        <div class="halloween-bat halloween-bat-b" aria-hidden="true" style="left: 60.59%; top: 29.63%; width: 4.19%;">
                            <img src="images/home_gallery/slider/000-halloween-bat-b.webp" width="70" height="30" alt="" />
                        </div>`;

// Ragnetto che scende col filo davanti alla luna (indipendente dai pipistrelli).
const HALLOWEEN_SPIDER = true;

export const HALLOWEEN_SPIDER_HTML = ` <div class="halloween-spider" aria-hidden="true">
                            <div class="halloween-spider-drop">
                                <span class="halloween-spider-thread"></span>
                                <svg class="halloween-spider-body" viewBox="0 0 40 36" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" stroke="#120d1c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M17 13 L9 5 L3 9" /><path d="M16 16 L6 12 L1 17" />
                                        <path d="M16 19 L6 21 L2 27" /><path d="M17 21 L10 28 L8 34" />
                                        <path d="M23 13 L31 5 L37 9" /><path d="M24 16 L34 12 L39 17" />
                                        <path d="M24 19 L34 21 L38 27" /><path d="M23 21 L30 28 L32 34" />
                                    </g>
                                    <ellipse cx="20" cy="21" rx="6" ry="7.5" fill="#120d1c" />
                                    <circle cx="20" cy="11.5" r="4.2" fill="#120d1c" />
                                    <circle cx="18.4" cy="11" r="1.1" fill="#ff8a1c" />
                                    <circle cx="21.6" cy="11" r="1.1" fill="#ff8a1c" />
                                </svg>
                            </div>
                        </div>`;

export const SLIDES_DATA: GallerySlideContent[] = [
    {
        // Halloween: logo già nell'immagine, solo il pulsante in basso (sopra il vialetto).
        // Resta il doppio delle altre. Visibile solo dal 15/10 al 1/11 inclusi (SeasonalThemeService).
        imageUrl: HALLOWEEN_ANIMATED_BATS
            ? 'images/home_gallery/slider/000-halloween.webp'
            : 'images/home_gallery/slider/000-halloween-pipistrelli.webp',
        width: 1472,
        height: 666,
        html_content: (HALLOWEEN_ANIMATED_BATS ? HALLOWEEN_BATS_HTML : '') + (HALLOWEEN_SPIDER ? HALLOWEEN_SPIDER_HTML : '') + `
                        <div style="position: absolute; left: 0; right: 0; bottom: 8%;">
                            <div class="flex text-transform-none animate__animated animate__fadeInUpBig animate__delay-2s">
                                <div style="width: 200px; margin: 0 auto; text-align: center;">
                                    <a onmousedown="event.stopPropagation()" onmousemove="event.stopPropagation()" onmouseup="event.stopPropagation()" style="background-color: #f8f00c; color: #000; border-radius: 16px; padding: 10px;" href="/c/i/automazioni-came/kit-completi-cancelli-a-battente/72" class="hov_white">{{slide.buynow}}</a>
                                </div>
                            </div>
                        </div>`,
        trad_keys: ["slide.buynow"],
        durationFactor: 2,
        season: 'halloween'
    },
    {
        imageUrl: 'images/home_gallery/slider/001-faac.webp',
        width: 1472,
        height: 832,
        html_content: ` <div class="banner-layer d-flex flex-column">
                            <!-- <h6 class="text-transform-none slide-disponibili">{{slide.disponibili_ora}}</h6> -->
                            <p class="h2 text-transform-none slide-ricambi-originali">{{slide.ricambi_originali}}</p>
                            <h3 class="slide-marca">FAAC</h3>
                            <div class="flex text-transform-none animate__animated animate__fadeInDownBig animate__delay-2s">
                                <div style="width: 200px; margin: 0 auto; padding-top: 10px; text-align: center;">
                                    <a onmousedown="event.stopPropagation()" onmousemove="event.stopPropagation()" onmouseup="event.stopPropagation()" style="background-color: #f8f00c; color: #000; border-radius: 16px; padding: 10px;" href="/c/i/ricambi-faac/686"class="hov_white">{{slide.buynow}}</a>
                                </div>
                            </div>
                            <!-- <span class="text-transform-none animate__animated animate__rollIn animate__delay-1s">
                                <span class="slide-extra">EXTRA!</span>
                            </span> -->
                            <!-- <h4 class="d-inline-block animate__animated animate__fadeInDownBig animate__delay-2s slide-sconti-wrap">
                                <sup class="slide-sconto">{{slide.sconti}}</sup>
                                <span class="slide-sconto-perc">50%</span>
                            </h4> -->
                            <img class="img-fluid slide-img-001 animate__animated animate__bounceInDown animate__delay-1s" src="images/home_gallery/slider/001-faac-img01.webp" alt="FAAC" />
                            <img class="img-fluid slide-img-002 animate__animated animate__bounceInDown animate__delay-2s" src="images/home_gallery/slider/001-faac-img02.webp" alt="FAAC" />
                            <img class="img-fluid slide-img-003 animate__animated animate__bounceInDown animate__delay-3s" src="images/home_gallery/slider/001-faac-img03.webp" alt="FAAC" />
                        </div>`,
        trad_keys: ["slide.disponibili_ora", "slide.ricambi_originali", "slide.sconti", "slide.buynow"]
    },
    {
        imageUrl: 'images/home_gallery/slider/002-ricambi_came.webp',
        width: 1028,
        height: 465,
        html_content: ` <div class="" style="width: 100%;">
                            <p style="color: #faf10c; width: 100%; text-align: center;" class="h2 d-block animate__animated animate__rollIn animate__delay-05s">
                                <span style="border-bottom: 3px solid #faf10c!important;">{{slide.dispon}}</span>
                            </p>
                            <div class="flex text-transform-none animate__animated animate__lightSpeedInLeft animate__delay-1s" style="padding: 5px; text-align: center; color: #fff;">
                                {{slide.came_original}}
                            </div>
                            <div class="flex text-transform-none animate__animated animate__fadeInDownBig animate__delay-2s">
                                <div style="width: 200px; margin: 0 auto; padding-top: 10px; text-align: center;">
                                    <a onmousedown="event.stopPropagation()" onmousemove="event.stopPropagation()" onmouseup="event.stopPropagation()" style="background-color: #f8f00c; color: #000; border-radius: 16px; padding: 10px;" href="/c/i/ricambi-came/670"class="hov_white">{{slide.buynow}}</a>
                                </div>
                            </div>
                        </div>`,
        trad_keys: ["slide.dispon", "slide.came_original", "slide.buynow"]
    },
    {
        imageUrl: 'images/home_gallery/slider/005-vortice.webp',
        width: 1030,
        height: 465,
        html_content: ` <div class="" style="width: 100%;">
                            <p style="color: #fff; width: 100%; text-align: center; padding-bottom: 20px;" class="h2 d-block animate__animated animate__rollIn animate__delay-05s">
                                <span style="border-bottom: 3px solid #fff!important;">VORTICE</span>
                            </p>
                            <div class="flex text-transform-none animate__animated animate__bounceInUp animate__delay-2s">
                                <div style="width: 200px; margin: 0 auto; padding-top: 10px; text-align: center;">
                                    <a onmousedown="event.stopPropagation()" onmousemove="event.stopPropagation()" onmouseup="event.stopPropagation()" style="background-color: #f8f00c; color: #000; border-radius: 16px; padding: 10px;" href="/c/i/vortice/1" class="hov_white">{{slide.buynow}}</a>
                                </div>
                            </div>
                        </div>`,
        trad_keys: ["slide.buynow"]
    },
    {
        imageUrl: 'images/home_gallery/slider/003-cancelli.webp',
        width: 1028,
        height: 465,
        html_content: ` <div class="" style="width: 100%;">
                            <p style="color: #fff; width: 100%; text-align: center; padding-bottom: 20px;" class="h2 d-block animate__animated animate__fadeInUpBig animate__delay-05s">
                                <span style="border-bottom: 3px solid #fff!important;">{{slide.automatic_gates}}</span>
                            </p>
                            <div class="flex text-transform-none animate__animated animate__fadeInDownBig animate__delay-1s">{{slide.best_marque}}</div>
                            <div class="flex text-transform-none animate__animated animate__zoomInLeft animate__delay-2s">
                                <div style="width: 200px; margin: 20px auto; padding-top: 10px; text-align: center;">
                                    <a onmousedown="event.stopPropagation()" onmousemove="event.stopPropagation()" onmouseup="event.stopPropagation()" style="background-color: #f8f00c; color: #000; border-radius: 16px; padding: 10px;" href="/c/i/automazioni-came/kit-completi-cancelli-a-battente/72" class="hov_white">{{slide.buynow}}</a>
                                </div>
                            </div>
                        </div>`,
        trad_keys: ["slide.buynow", "slide.best_marque", "slide.automatic_gates"]
    }
];